import { createContext, ReactNode, useReducer } from 'react'

import { InitUserInfo, UserInfo } from '@models/user.model'
import { LandingPageProjectInfo } from '@models/projects.model'
import { InitMyOrganizationInfo, MyOrganizationInfo } from '@models/organization.model'
import KeycloakWrapper from './keycloakWrapper'
import AuthReducer, { ActionType } from './reducer'

export interface AuthProps {
	userInfo: UserInfo
	organizationInfo: MyOrganizationInfo
	landingPageProjects: LandingPageProjectInfo[]
	completedInitiated: boolean
}

const initialGlobalState: AuthProps = {
	userInfo: InitUserInfo,
	organizationInfo: InitMyOrganizationInfo,
	landingPageProjects: [],
	completedInitiated: false,
}

export const AuthContext = createContext<{
	state: AuthProps
	dispatch: React.Dispatch<ActionType>
}>({
	state: initialGlobalState,
	dispatch: () => undefined,
})

interface Props {
	children?: ReactNode
}

export const AuthProvider = ({ children, ...props }: Props) => {
	const [state, dispatch] = useReducer(AuthReducer, initialGlobalState)
	return (
		<AuthContext.Provider value={{ state, dispatch }}>
			<KeycloakWrapper>{children}</KeycloakWrapper>
		</AuthContext.Provider>
	)
}
